import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getLatestCommit } from '../services/api';

const ProjectLatestCommit = ({ projectId }) => {
  const [commit, setCommit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLatestCommit = async () => {
      try {
        setLoading(true);
        const { data } = await getLatestCommit(projectId);
        setCommit(data);
        setError(null);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load commit info');
      } finally {
        setLoading(false);
      }
    };

    if (projectId) {
      fetchLatestCommit();
    }
  }, [projectId]);

  if (loading) return <div className="text-gray-500 text-sm p-4">Loading latest commit...</div>;
  if (error) return <div className="text-red-500 text-sm p-4">Error: {error}</div>;
  if (!commit) return null;

  return (
    <div className="bg-white shadow rounded-lg p-6 border border-gray-200 mt-4">
      <h3 className="text-lg font-medium text-gray-900 border-b pb-2 mb-4">
        Latest Git Commit
      </h3>
      
      <div className="flex flex-col gap-2">
        <p className="text-gray-800 font-semibold text-md font-mono">
          {commit.message}
        </p>
        
        <div className="text-sm text-gray-600 mt-1">
          <span className="font-medium">Author:</span> {commit.author}
        </div>
        
        <div className="text-sm text-gray-600">
          <span className="font-medium">Date:</span> {new Date(commit.date).toLocaleString()}
        </div>
        
        <div className="mt-3">
          <a
            href={commit.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800 text-sm font-medium hover:underline flex items-center"
          >
            View on GitHub <span className="ml-1">&rarr;</span>
          </a>
        </div>
        
        <div className="text-xs text-gray-400 mt-2 font-mono">
          SHA: {commit.sha.substring(0, 7)}
        </div>
      </div>
    </div>
  );
};

ProjectLatestCommit.propTypes = {
  projectId: PropTypes.string.isRequired,
};

export default ProjectLatestCommit;
